export const getInitials = (name?: string): string | undefined => {
    if (! name) {
        return undefined
    }

    const parts = name.trim().split(/\s+/)

    if (parts.length === 1) {
        return parts[0].slice(0, 2).toUpperCase()
    }

    return `${parts[0][0]}${parts[parts.length - 1][0]}`.toUpperCase()
}
